import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description ChartDown icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { ChartDown } from '@sravni/design-system-icons'
 *
 * <ChartDown />
 * ```
 */
var ChartDown = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "ChartDown", viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#ChartDown__a)", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" },
        React.createElement("path", { d: "M4.903 5.833 9.13 10.06a.832.832 0 0 0 1.178 0l1.785-1.784a.832.832 0 0 1 1.178 0l4.967 4.966" }),
        React.createElement("path", { d: "M16.014 13.24h2.222v-2.222M18.237 17.44H2.34V2.685" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "ChartDown__a" },
            React.createElement("path", { fill: "currentColor", transform: "translate(.736)", d: "M0 0h20v20H0z" }))))); });

export { ChartDown };
//# sourceMappingURL=ChartDown.js.map
